<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vx-card>
                <div slot="no-body">
                </div>
                <h5 class="mb-2"> Client </h5>
                    <div class="content-center">


                        <!-- NAME -->

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Nom" disabled="" v-model="dataIntervention.client.lastname" class="w-full" name="lastname"/>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Prénom" disabled="" v-model="dataIntervention.client.firstname" class="w-full" name="firstname" />
                            </div>
                        </div>

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Company" disabled="" v-model="dataIntervention.client.company" class="w-full" name="company" />
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Siret" disabled="" v-model="dataIntervention.client.siret" class="w-full" name="siret" />
                            </div>
                        </div>

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Email" disabled="" v-model="dataIntervention.client.email" class="w-full" name="client_email" />

                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Téléphone" disabled="" v-model="dataIntervention.client.tel" class="w-full" name="client_tel" />

                            </div>
                        </div>

                        <div class="vs-component vs-con-input-label vs-input mt-5 w-full vs-input-primary">
                          <label for="textarea-default" class="vs-input--label mt-5">Adresse</label>
                          <vs-textarea id="textarea-default" disabled="" rows="3"  name="client_address" v-model="dataIntervention.client.address" />

                        </div>

                        <div class="vx-row mt-5">
                          <div class="vx-col md:w-1/2 w-full">
                            <vs-input label="Ville" disabled="" v-model="dataIntervention.client.city" class="w-full" name="client_city" />

                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <vs-input label="Code postal" disabled="" v-model="dataIntervention.client.zipcode" class="w-full" name="client_zipcode" />

                          </div>
                        </div>

                    </div>
            </vx-card>
          </div>
        </div>
        <!-- <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vx-card>
              <h5 class="mb-2"> Photos </h5>
                <div class="content-center">
                  <silent-box ref="silentbox" :gallery="gallery" v-if="gallery.length">
                      <template v-slot:silentbox-item="{ silentboxItem }">
                          <img :src="silentboxItem.src" style="width: 200px !important;height: 150px !important;margin-right: 5px;border-radius: 5px;">
                          <vs-button color="danger" type="flat" class="w-full" @click.prevent="deleteImage(silentboxItem.id)"><feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" /> Supprimer</vs-button>
                      </template>
                  </silent-box>

                  <div class="vx-row mt-5">
                    <div class="vx-col w-full text-center">
                      <vs-button type="gradient" color="success" class="w-full" @click="showCamera = true">Ajouter photo</vs-button>
                    </div>
                  </div>
                </div>
            </vx-card>
          </div>
        </div> -->
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vx-card>
              <div slot="no-body">
              </div>
              <h5 class="mb-2">Intervention </h5>
              <div class="content-center">

                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Etat</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                            <v-select name="etat_emergency" class="w-full" disabled="" :clearable="false" label="label" v-model="dataIntervention.emergency" :options="Emergency_choices" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                            </v-select>
                          </div>

                      </vx-input-group>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input vs-input-primary w-full">
                      <label  class="vs-input--label">Date</label><br/>
                      <flat-pickr :config="configdateTimePicker" v-model="dataIntervention.date" disabled="" name="date_intervention" class="w-full"  />

                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-input label="Lieu " v-model="dataIntervention.lieu" disabled="" class="w-full" name="lieu_intervention"  />

                  </div>
                  <div class="vx-col md:w-1/2 w-full ">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary " >
                      <label for="" class="vs-input--label pr-5">Etat</label>
                        <vx-input-group class="mb-base">
                          <div class="flex">
                            <v-select name="etat_intervention" class="w-full "  :clearable="false"  label="label" v-model="dataIntervention.status" :options="Status_choices" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                                <div slot="no-options">Désolé, aucune etat correspondante.</div>
                            </v-select>
                          </div>
                        </vx-input-group>

                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Catégorie</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="categorie_intervention" class="w-full " disabled="" :clearable="false" label="name" v-model="dataIntervention.categorie" :options="Services_choices" :reduce="service => service.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                              <div slot="no-options">Désolé, aucune catégorie correspondante.</div>
                          </v-select>
                          </div>
                      </vx-input-group>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Type de problème</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="sub_categorie_intervention" class="w-full " disabled="" :clearable="false" label="titre" v-model="dataIntervention.subcategorie" :options="SubServices_choices_filtred" :reduce="subservice => subservice.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                              <div slot="no-options">Désolé, aucune type correspondante.</div>
                          </v-select>
                          </div>

                      </vx-input-group>
                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-input label="Prix annoncé" disabled="" v-model="dataIntervention.price" class="w-full" />
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                  </div>
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="textarea-default" class="vs-input--label ">Description problème</label>
                      <vs-textarea  rows="3" disabled="" name="description_intervention" v-model="dataIntervention.description"  />

                    </div>
                  </div>
                </div>



              </div>

          </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/3  w-full ">


        <!-- <vs-button class="mr-5" type="border" v-if="dataIntervention.quote_api_id" color="success"  @click="open">Signature</vs-button>

        <vs-popup class="holamundo" title="Signature" :active.sync="popupActive">
            <VueSignaturePad
            id="signature"
            width="100%"
            height="150px"
            ref="signaturePad"
          />
          <div class="row">
            <div class="vx-col md:w-1/2  w-full mt-2">
              <vs-button color="primary" class="pr-4 pl-4" type="border" @click="save">Enregisterer</vs-button>
            </div>
            <div class="vx-col md:w-1/2  w-full text-right  mt-2">
              <vs-button color="primary" class="pr-4 pl-4" type="border" @click="undo">Effacer</vs-button>
            </div>
          </div>
        </vs-popup> -->

      </div>
      <div class="vx-col md:w-2/3  w-full text-right">
        <vs-button class="mr-2 ml-2 mb-1 button-download" type="border" color="success"  v-if="dataIntervention.quote_api_id"  @click="downloadPdfQuote">Télécharger le devis</vs-button>
        <vs-button class="mr-2 ml-2 mb-1 button-download" type="border" color="success"  v-if="dataIntervention.invoice_api_id"  @click="downloadPdf">Télécharger la facture</vs-button>
        <vs-button class="mr-2 ml-2 mb-1" type="gradient" @click="saveClientAndInterventionData()">{{ dataIntervention.id ? 'Mettre à jour l\'intervention' : 'Créer l\'intervention' }}</vs-button>
      </div>
    </div>

    <!-- <camera :isSidebarActive="showCamera" @closeSidebar="showCamera = false" :intervention_id="dataIntervention.id" @addImage="addImage($event)" /> -->
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { VueEditor } from "vue2-editor"
import { mapActions, mapGetters } from 'vuex'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { French } from 'flatpickr/dist/l10n/fr.js'

import VueSilentbox from 'vue-silentbox'
import camera from './camera'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
  custom: {
    date_intervention: {
      required: 'La date d\'intervention est obligatoire'
    },
    lieu_intervention: {
      required: 'Le lieu d\'intervention est obligatoire'
    },
    description_intervention: {
      required: 'La description de problème est obligatoire'
    },
    categorie_intervention : {
      required: 'La catégorie d\'intervention est obligatoire'
    },

    client_email : {
      required: 'L\'email de client est obligatoire'
    },
    client_tel : {
      required: 'Le téléphone de client est obligatoire'
    },
    client_city : {
      required: 'La ville de client est obligatoire'
    },
    client_zipcode : {
      required: 'Le code postal de client est obligatoire'
    },
    client_address : {
      required: 'L\'adresse de client est obligatoire'
    },
    sub_categorie_intervention: {
      required: 'Le type de problème est obligatoire'
    }


  }
};

// register custom messages
Validator.localize('fr', dict);

export default {
name: 'MySignaturePad',
  components: {
    vSelect,
    flatPickr,
    VueEditor,
    VueSilentbox,
    camera
  },
  props: ['dataIntervention'],
  data () {
    return {
      id: null,
      artisansPopupActive: false,
      configdateTimePicker: {
        locale: French,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      Status_choices : [
        {label: 'Brouillon', value: 0},
        {label: 'Valider', value: 1},
        {label: 'En cours', value: 2},
        {label: 'Terminer', value: 3},
        {label: 'Refuser', value: 4}
      ],
      Emergency_choices : [
        {label: 'En urgence', value: 1},
        {label: 'Sur rendez-vous', value: 0}
      ],
      itemsPerPage: 10,
      f_services_id: null,
      f_secteurs_id: null,
      f_disponibilites: 'Tous',
      f_city_id: null,
      f_search: "",
      first_load: true,
      popupActive: false,
      image : {id: null, base64: null},

      showCamera: false,
      gallery: []

    }
  },
  created () {
    this.fetchArtisans()
    this.fetchClients()
    this.fetchServices()
    this.fetchSubServices()
    this.fetchSecteur()
    this.fetchCities()
    this.fetchInterventions()

  },
  computed: {
    ...mapGetters('artisans', {'Artisan_choices' : 'GET_ITEMS'}),
    ...mapGetters('clients', {'Clients_choices' : 'GET_ITEMS'}),
    ...mapGetters('services', {'Services_choices' : 'GET_ITEMS'}),
    ...mapGetters('subservices', {'SubServices_choices' : 'GET_ITEMS'}),
    ...mapGetters('secteurs', {'Secteur_choices' : 'GET_ITEMS'}),
    ...mapGetters('cities', {'Cities_choices' : 'GET_ITEMS'}),
    ...mapGetters('interventions', {'interventions' : 'GET_ITEMS','intervention' : 'GET_ITEM'}),

    SubServices_choices_filtred() {
      return this.SubServices_choices.filter(subservice => {
        return subservice.service_id == (this.dataIntervention.categorie ? this.dataIntervention.categorie : -1)
      })
    },

    filteredArtisansItems() {
      let dataFilter = null
      if(this.f_services_id == null || this.f_services_id.length == 0) {
        dataFilter = this.Artisan_choices
      }else{
        dataFilter = this.Artisan_choices.filter(item => {
          return item.services.findIndex(service => (this.f_services_id.includes(service.id))) > -1
        })
      }

      if(this.f_secteurs_id != null && this.f_secteurs_id.length > 0) {
       dataFilter = dataFilter.filter(item => {
          return item.secteurs.findIndex(secteur => (this.f_secteurs_id.includes(secteur.id))) > -1
        })
      }

      if(this.f_disponibilites != 'Tous'){
        dataFilter = dataFilter.filter(item => {
          return item.availability.indexOf(this.f_disponibilites) > -1
        })
      }

      if(this.f_city_id != null && this.f_city_id.length > 0){
        dataFilter = dataFilter.filter(item => {
          return this.f_city_id.includes(item.city_id)
        })
      }

      if(this.f_search != null && this.f_search != "") {
        dataFilter = dataFilter.filter(item => {
          return item.lastname.trim().toLowerCase().concat(' ',item.firstname.trim().toLowerCase()).includes(this.f_search.toLowerCase()) || item.firstname.trim().toLowerCase().concat(' ',item.lastname.trim().toLowerCase()).includes(this.f_search.toLowerCase())
        })
      }

      return dataFilter

    }
  },
  methods: {
    ...mapActions('artisans', {'fetchArtisans': 'fetchItems'}),
    ...mapActions('clients', {'fetchClients':'fetchItems', 'addClient' : 'addItem', 'updateClient' : 'updateItem'}),
    ...mapActions('services', {'fetchServices':'fetchItems'}),
    ...mapActions('subservices', {'fetchSubServices':'fetchItems'}),
    ...mapActions('interventions', {'addIntervention':'addItem', 'getIntervention':'getItem', 'updateIntervention':'updateItemEtat', 'fetchInterventions':'fetchItems','saveImage':'saveImage', 'fetchImages' : 'fetchImages','removeImage' : 'removeImage'}),
    ...mapActions('secteurs', {'fetchSecteur' : 'fetchItems'}),
    ...mapActions('cities', {'fetchCities' : 'fetchItems'}),

    changeStatus(old_status_label, new_status_label,value) {
      if(old_status_label != new_status_label){
        this.dataIntervention.status.value = value;
        this.dataIntervention.status.label = new_status_label;
        this.updateInterventionData()

      }
    },

    downloadPdf() {
      let a = document.createElement("a");
      a.setAttribute("href", `https://hellodepann.vosfactures.fr/invoices/${this.dataIntervention.invoice_api_id}.pdf?api_token=8hpAUs73rV4vbcDRoDo`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    
    downloadPdfQuote() {
        let a = document.createElement("a");
        a.setAttribute("href", `https://hellodepann.vosfactures.fr/invoices/${this.dataIntervention.quote_api_id}.pdf?api_token=8hpAUs73rV4vbcDRoDo&invoice_template_id=8397`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },



    updateInterventionData() {
      this.updateIntervention(this.dataIntervention).then(() => {
        this.successMsg("Modification","L'intervention' est bien modifié");
      }).catch(() => {
        this.errorMsg('Modification','Trouvé un error lor de la modification')
      })
    },

    saveClientAndInterventionData() {

        this.$emit('showLoading')
        if(this.dataIntervention.client_id) {
            this.updateClient(this.dataIntervention.client).then(() => {
                if(this.dataIntervention.id){
                    this.updateInterventionData()
                }

                this.$emit('closeLoading')
            }).catch(err => {
                this.$emit('closeLoading')
                this.errorMsg('Modification de client','Trouvé un error lor de la modification de client')
            })
        }
        return true


    },

    open() {
      this.popupActive = true;
      this.$refs.signaturePad.undoSignature();
      this.$nextTick(() => {
        this.$refs.signaturePad.resizeCanvas();
      })
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.image.id = this.dataIntervention.quote_api_id;
      this.image.base64 = data;
        console.log(isEmpty);
      console.log(data);
      this.saveImage(this.image).then(() => {
        this.successMsg("Modification","L'enregistrement' l'image est bien effectué");
      }).catch(() => {
        this.errorMsg('Modification',"Trouvé un error L'enregistrement' l'image")
      })


    },
    change() {
      this.options = {
        penColor: "#00f"
      };
    },
    resume() {
      this.options = {
        penColor: "#c0f"
      };
    },
    showImg(index) {
      this.index = index
      this.visible = true
    },

    handleHide() {
      this.visible = false
    },

    addImage(image) {
      this.gallery.push(image)
    },

    deleteImage(id) {
      this.removeImage(id).then(() => {
        const ItemIndex = this.gallery.findIndex((p) => p.id == id)
        this.gallery.splice(ItemIndex, 1)
        this.$refs.silentbox.hideOverlay()
        this.successMsg("Supprission photo","La photo est bien supprimé");
      }).catch(() => {
        this.errorMsg('Supprission photo','Trouvé un error lor de la supprission')
      })
    }

  },
  mounted(){

  },
  watch: {
    'dataIntervention.client_id'(val) {
      if(val) {
        let client = this.Clients_choices[this.Clients_choices.findIndex((client) => client.id == this.dataIntervention.client_id)]

        this.dataIntervention.client = {
          id: client.id,
          address: client.address,
          company: client.company,
          email: client.email,
          firstname: client.firstname,
          lastname: client.lastname,
          siret: client.siret,
          status: client.status,
          tel: client.tel,
          city: client.city,
          zipcode: client.zipcode,
          emergency: client.emergency
        }
      }
    },

    'dataIntervention.id'(val) {
      this.$emit('changeId', val)
      if(!val) this.errors.items = []

      this.fetchImages(val).then(response => {
        this.gallery = response.data
      })
    },

    'dataIntervention.categorie'() {
      if(this.SubServices_choices_filtred.findIndex(subservice => subservice.id == this.dataIntervention.subcategorie) == -1)
        this.dataIntervention.subcategorie = null
    },
    'dataIntervention.subcategorie'(val) {

        if(!this.first_load || !this.dataIntervention.id) {
          let montant = val ? this.SubServices_choices_filtred[this.SubServices_choices_filtred.findIndex(subservice => subservice.id == val)].montant : null
          this.dataIntervention.price = montant
        }

        this.first_load = false
    },
    'dataIntervention.client.city'(val) {
      this.dataIntervention.lieu = val
    }
  }

}
</script>
<style>
  .vs__selected{
    text-transform: uppercase;
  }

  #signature {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
      radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  .con-vs-popup .vs-popup{
    width: 300px;
  }

  #silentbox-overlay {
    z-index: 99999 !important;
  }

  .vs-sidebar.vs-sidebar-primary.vs-sidebar-position-right {
    z-index: 99999 !important;
    max-width: 500px !important;
  }

  .button-download{
    min-width: 240px;
  }

  @media only screen and (max-width: 600px) {
    .text-right{
      text-align: center !important;
    }
  }
</style>
